// Gliederung des Anzeigentexts unter der h1 der Anzeige (#236): die oberste
// Ueberschrift des Markdown wird h2, die uebrigen folgen im selben Abstand,
// hoechstens h6. Die Ebene der Quelle bleibt als Klasse md-hN — an ihr haengt
// das Aussehen (jobsPublic.scss), damit die neue Ebene es nicht aendert.
// Arbeitet auf dem mdast-Baum; als remark-Plugin: () => ueberschriftenUnterH1.
const ueberschriften = (knoten) => [
    ...('heading' === knoten.type ? [knoten] : []),
    ...(knoten.children || []).flatMap(ueberschriften)
]

export const ueberschriftenUnterH1 = (tree) => {
    const alle = ueberschriften(tree)
    if (0 === alle.length) return

    const verschiebung = 2 - Math.min(...alle.map(u => u.depth))
    alle.forEach(u => {
        u.data = { ...u.data, hProperties: { ...u.data?.hProperties, className: `md-h${u.depth}` } }
        u.depth = Math.min(u.depth + verschiebung, 6)
    })
}
